<template>
  <div class="box-tent">
    <div class="box-tent-tit">
      <h3>{{screenName}}</h3>
    </div>

    <el-table
      :ref="'scroll_Table' + tableSet.id"
      :data="getData"
      stripe
      height="100%"
      style="width: 100%;"
      @mouseleave.native="autoScroll(false)"
      @mouseenter.native="autoScroll(true)">
      <el-table-column
        prop="name"
        show-overflow-tooltip
        label="产品"
        width="500">
      </el-table-column>
      <el-table-column label="日均" align="center" width="260">
        <template slot-scope="{ row }">
          <span>{{ row.value }}</span>
        </template>
      </el-table-column>
      <el-table-column label="上期" align="center" width="260">
        <template slot-scope="{ row }">
          <span>{{ row.lastValue }}</span>
        </template>
      </el-table-column>
      <el-table-column label="涨跌" align="center" width="220">
        <template slot-scope="{ row }">
          <span :class="row.spread > 0 ? 'red' : (row.spread < 0 ? 'green' : '')">{{ row.spread | dataFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column label="涨幅" align="center" width="240">
        <template slot-scope="{ row }">
          <span style="display: inline-block; width: 204px" :class="row.percentage > 0 ? 'bg-red' : (row.percentage < 0 ? 'bg-green' : '')">
            {{isNaN(row.percentage) || !row.percentage ? row.percentage : row.percentage * 1 + '%'}}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="日期" align="center" width="200">
        <template slot-scope="{ row }">
          <span style="font-size: 45px">{{ row.date.slice(5, 10) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'screen2',
  props: {
    tableSet: {},
    getData: {
      default: function () {
        return []
      }
    },
    screenName: {}
  },
  filters: {
    dataFormat (value) {
      return !isNaN(value) && value ? (value * 1).toFixed(6) * 1 : value
    }
  },
  data () {
    return {
      scrollTimer: '',
    }
  },
  mounted () {
    this.autoScroll(false)
  },
  beforeDestroy () {
    this.autoScroll(true)
  },
  methods: {
    autoScroll(stop) {
      const table = this.$refs['scroll_Table' + this.tableSet.id]
      const divData = table.$refs.bodyWrapper
      if (stop) {
        window.clearInterval(this.scrollTimer)
      } else {
        this.scrollTimer = window.setInterval(() => {
          divData.scrollTop += 2
          if (divData.clientHeight + divData.scrollTop === divData.scrollHeight) {
            divData.scrollTop = 0
          }
        }, 100)
      }
    }
  }
}
</script>
<style scoped>
.box-tent{
  position: absolute;
  width: 116%;
  height: calc(100% - 30px);
  top: 60px;
  left: -8%;
  box-sizing: border-box;
  padding: 0 14% 15% 14%;
  background: url("../../../assets/ale/box-bg.png") no-repeat center/contain
}
.box-tent-tit{
  height: 14%;
  padding-top: 4.5%;
}
.box-tent-tit h3{
  font-size: 70px;
  color: #fff;
  margin-left: 5%;
}
.red{
  color: #E94341!important;
}
.green{
  color: #00C07B!important;
}

.bg-red{
  color: #fff!important;
  background: #E94341!important;
}
.bg-green{
  color: #fff!important;
  background: #00C07B!important;
}
</style>
<style>
.box-tent .el-table{
  background: #001556;
  font-size: 60px;
}
.box-tent .el-table::before{
  background: none;
}
.box-tent .el-table tr{
  background: #001556;
  color: #fff;
}
.box-tent .el-table .cell{
  line-height: initial;
}
.box-tent .el-table th.el-table__cell.is-leaf{
  border-bottom: 1px solid #001556;
}
.box-tent .el-table td.el-table__cell{
  border-bottom: none;
}
.box-tent .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell{
  background: #092E73;
}
.box-tent .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell{
  background: #0B3480;
}
.box-tent .el-table th.el-table__cell{
  background: #092E73;
  color: #3ACEE4;
}
</style>



// WEBPACK FOOTER //
// src/views/ale/modules/screen2.vue